import { createContext } from 'react';
import type { TransactionStatus, TransactionType } from '../heyapi';

export const CurrentTransactionContext = createContext<{
  currentTransactionStatus: TransactionStatus | null | undefined;
  currentTransactionType: TransactionType | null | undefined;
  currentTransactionEffectiveDate: Date | null | undefined;
}>({
  currentTransactionStatus: null,
  currentTransactionType: null,
  currentTransactionEffectiveDate: null,
});
